import { asTrimmedId } from '@/utils/ids'
import { LocationsRequest, LocationsResponse, LocationType } from '../../types/widget'
import { safeFetchAPI, SafeFetchOptions, SafeFetchResponse } from '../index'
import { API_BASE } from './index'

export function normalizeLocationsResponse(data: LocationsResponse): LocationsResponse {
  return {
    ...data,
    ecomLocations: (data.ecomLocations ?? []).map((location) => ({
      ...location,
      storeID: asTrimmedId(location.storeID) ?? '',
    })),
  }
}

export async function getLocations(
  payload: LocationsRequest,
  locType: LocationType = 'all',
  options?: Partial<SafeFetchOptions>
): Promise<SafeFetchResponse<LocationsResponse>> {
  const [data, error] = await safeFetchAPI<LocationsResponse>(`${API_BASE}/widget/locations`, {
    method: 'POST',
    payload,
    queryParams: { locType },
    ...options,
  })
  if (error || !data) return [undefined, error ?? 'Invalid locations response']
  return [normalizeLocationsResponse(data), undefined]
}
